import { render, staticRenderFns } from "./icon-question.vue?vue&type=template&id=48a8a0cb&scoped=true&"
import script from "./icon-question.vue?vue&type=script&lang=js&"
export * from "./icon-question.vue?vue&type=script&lang=js&"
import style0 from "./icon-question.vue?vue&type=style&index=0&id=48a8a0cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a8a0cb",
  null
  
)

export default component.exports